export default __webpack_public_path__ + "static/media/remingtonWebsite@2x.03500ee3.jpg";